import { render, staticRenderFns } from "./inspectionTaskDetailsList.vue?vue&type=template&id=79659a3c&scoped=true"
import script from "./inspectionTaskDetailsList.vue?vue&type=script&lang=js"
export * from "./inspectionTaskDetailsList.vue?vue&type=script&lang=js"
import style0 from "./inspectionTaskDetailsList.vue?vue&type=style&index=0&id=79659a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79659a3c",
  null
  
)

export default component.exports